import { NgModule, NgModuleFactory, ModuleWithProviders } from '@angular/core';
import { CoreModule, LazyModuleFactory } from '@abp/ng.core';
import { ThemeSharedModule } from '@abp/ng.theme.shared';
import { AnalysisComponent } from './components/analysis.component';
import { AnalysisRoutingModule } from './analysis-routing.module';
import { NgxValidateCoreModule } from '@ngx-validate/core';
import { NgbModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { CommercialUiModule } from '@volo/abp.commercial.ng.ui';
import { ThemeLeptonModule } from '@volo/abp.ng.theme.lepton';
import { ResourceTypeComponent } from './components/resource-type/resource-type.component';
import { ResourceComponent } from './components/resource/resource.component';
import { EventTypeComponent } from './components/event-type/event-type.component';
import { AUserComponent } from './components/auser/auser.component';
import { ResourceEventComponent } from './components/resource-event/resource-event.component';
import { StatComponent } from './components/stat/stat.component';
import {FormsModule} from '@angular/forms';

@NgModule({
  declarations: [
    AnalysisComponent, 
    ResourceTypeComponent, 
    ResourceComponent,
    EventTypeComponent,
    AUserComponent,
    ResourceEventComponent,
    StatComponent,
  ],
  imports: [
    CoreModule, 
    ThemeSharedModule, 
    AnalysisRoutingModule,
    ThemeLeptonModule,
    CommercialUiModule,
    NgbDropdownModule,
    NgxValidateCoreModule,
    FormsModule, 
    NgbModule
  ],
  exports: [],
})
export class AnalysisModule {
  static forChild(): ModuleWithProviders<AnalysisModule> {
    return {
      ngModule: AnalysisModule,
      providers: [],
    };
  }

  static forLazy(): NgModuleFactory<AnalysisModule> {
    return new LazyModuleFactory(AnalysisModule.forChild());
  }
}
